import { render, staticRenderFns } from "./VulnerableByLGA.vue?vue&type=template&id=7a56e96e&"
import script from "./VulnerableByLGA.vue?vue&type=script&lang=js&"
export * from "./VulnerableByLGA.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports